export const Types = {
  GET_LIST_PROPOSTAS: "propostas/GET_LIST_PROPOSTAS",
  GET_LIST_PROPOSTAS_SUCCESS: "propostas/GET_LIST_PROPOSTAS_SUCCESS",
  GET_TOTALS_PROPOSTAS: "propostas/GET_TOTALS_PROPOSTAS",
  GET_TOTALS_PROPOSTAS_SUCCESS: "propostas/GET_TOTALS_PROPOSTAS_SUCCESS",
  GET_PROPOSTAS: "propostas/GET_PROPOSTAS",
  GET_PROPOSTAS_SUCCESS: "propostas/GET_PROPOSTAS_SUCCESS",
  GET_DOCS_PROPOSTAS: "propostas/GET_DOCS_PROPOSTAS",
  GET_DOCS_PROPOSTAS_SUCCESS: "propostas/GET_DOCS_PROPOSTAS_SUCCESS",
  EDIT_PROPOSTAS: "propostas/EDIT_PROPOSTAS",
  ADD_PROPOSTAS: "propostas/ADD_PROPOSTAS",
  DELETE_PROPOSTAS: "propostas/DELETE_PROPOSTAS",
  SEARCH_PROPOSTAS: "propostas/SEARCH_PROPOSTAS",
  CHANGE_PAGE_PROPOSTAS: "propostas/CHANGE_PAGE_PROPOSTAS",
  CHANGE_ROWS_PER_PAGE_PROPOSTAS: "propostas/CHANGE_ROWS_PER_PAGE_PROPOSTAS",
  GET_LIST_PROPOSTAS_SELECTS: "propostas/GET_LIST_PROPOSTAS_SELECTS",
  GET_LIST_PROPOSTAS_SUCCESS_SELECTS:
    "propostas/GET_LIST_PROPOSTAS_SUCCESS_SELECTS",
  PRINT: "propostas/PRINT",
  PRINT_SUCCESS: "propostas/PRINT_SUCCESS",
  CHANGE_FILTER: "propostas/CHANGE_FILTER",
  CHECK_COLUMN: "propostas/CHECK_COLUMN",
  CHECK_COLUMN_SUCCESS: "propostas/CHECK_COLUMN_SUCCESS",
  DELETE_ALL_PROPOSTAS: "propostas/DELETE_ALL_PROPOSTAS",
  RATE_PROPOSTAS: "propostas/RATE_PROPOSTAS",
  GET_PROPOSTA_HISTORY: "propostas/GET_PROPOSTA_HISTORY",
  GET_PROPOSTA_HISTORY_SUCCESS: "propostas/GET_PROPOSTA_HISTORY_SUCCESS",
  SET_PROPOSTAS_REPORT_FILTER: "propostas/SET_PROPOSTAS_REPORT_FILTER",
  GET_PROPOSTAS_RELATORIO: "propostas/GET_PROPOSTAS_RELATORIO",
  GET_PROPOSTAS_RELATORIO_SUCCESS: "propostas/GET_PROPOSTAS_RELATORIO_SUCCESS",
};

const INITIAL_STATE = {
  data: [],
  dataList: [],
  loadingSelect: false,
  item: {},
  filter: {},
  search: "",
  page: 0,
  rowsPerPage: localStorage.getItem("@ecorban-app:rows")
    ? parseInt(localStorage.getItem("@ecorban-app:rows"), 10)
    : 10,
  total: 0,
  total_financed: 0,
  total_released: 0,
  total_debit: 0,
  total_receipted_total: 0,
  total_estornado_total: 0,
  total_comissioned_total: 0,
  total_value_installment: 0,
  total_comissions_predict: 0,
  total_base: 0,
  total_mutiplier: 0,
  totals: 0,
  print: "",
  columns_settings: [],
  exp: "",
  reportFilter:{},
  reportDetail: {}
};

export default function propostas(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_LIST_PROPOSTAS:
      return {...state};
    case Types.GET_LIST_PROPOSTAS_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        total: action.payload.total,
        total_financed: action.payload.total_financed,
        total_released: action.payload.total_released,
        total_debit: action.payload.total_debit,
        total_base: action.payload.total_base,
        total_mutiplier: action.payload.total_mutiplier,
        total_receipted_total: action.payload.total_receipted_total,
        total_estornado_total: action.payload.total_estornado_total,
        total_comissioned_total: action.payload.total_comissioned_total,
        total_value_installment: action.payload.total_value_installment,
        total_receipt_predict: action.payload.total_receipt_predict,
        total_comissions_predict: action.payload.total_comissions_predict,
        columns_settings: action.payload.columns_settings,
        exp: action.payload.exp
      };
    case Types.GET_TOTALS_PROPOSTAS:
      return {...state};
    case Types.GET_TOTALS_PROPOSTAS_SUCCESS:
      return {
        ...state,
        totals: action.payload.totals
      };
    case Types.GET_PROPOSTAS_SUCCESS:
      return {
        ...state,
        item: action.payload.data
      };
    case Types.GET_DOCS_PROPOSTAS_SUCCESS:
      return {
        ...state,
        item: action.payload.data
      };
    case Types.ADD_PROPOSTAS:
      return {...state};
    case Types.DELETE_PROPOSTAS:
      return {...state};
    case Types.CHANGE_PAGE_PROPOSTAS:
      return {...state, page: action.payload.page};
    case Types.SEARCH_PROPOSTAS:
      return {...state, filter: action.payload.filter};
    case Types.CHANGE_ROWS_PER_PAGE_PROPOSTAS:
      return {...state, rowsPerPage: action.payload.total};
    case Types.GET_LIST_PROPOSTAS_SELECTS:
      return {...state, loadingSelect: true};
    case Types.GET_LIST_PROPOSTAS_SUCCESS_SELECTS:
      return {
        ...state,
        dataList: action.payload.propostas,
        loadingSelect: false
      };
    case Types.PRINT_SUCCESS:
      return {...state, print: action.payload.url};
    case Types.CHANGE_FILTER:
      return {
        ...state,
        filter: action.payload.data
      };
    case Types.CHECK_COLUMN_SUCCESS:
      return {...state, columns_settings: JSON.parse(action.payload.columns)};
    case Types.DELETE_ALL_PROPOSTAS:
      return {...state};
    case Types.GET_PROPOSTA_HISTORY_SUCCESS:
      return {
        ...state,
        item: action.payload.data
      };
    case Types.SET_PROPOSTAS_REPORT_FILTER:
      return {
        ...state,
        reportFilter: action.payload.data
      };
    case Types.GET_PROPOSTAS_RELATORIO_SUCCESS:
      return {
        ...state,
        reportDetail: action.payload.data
      };
    default:
      return state;
  }
}

export const Creators = {
  getListPropostas: () => ({
    type: Types.GET_LIST_PROPOSTAS
  }),
  getListPropostasSuccess: (
    data,
    total,
    total_financed,
    total_released,
    total_debit,
    total_base,
    total_mutiplier,
    total_receipted_total,
    total_estornado_total,
    total_comissioned_total,
    total_value_installment,
    total_receipt_predict,
    total_comissions_predict,
    columns_settings,
    exp
  ) => ({
    type: Types.GET_LIST_PROPOSTAS_SUCCESS,
    payload: {
      data,
      total,
      total_financed,
      total_released,
      total_debit,
      total_base,
      total_mutiplier,
      total_receipted_total,
      total_estornado_total,
      total_comissioned_total,
      total_value_installment,
      total_receipt_predict,
      total_comissions_predict,
      columns_settings,
      exp
    }
  }),
  getTotalsPropostas: () => ({
    type: Types.GET_TOTALS_PROPOSTAS
  }),
  getTotalsPropostasSuccess: (
    totals
  ) => ({
    type: Types.GET_TOTALS_PROPOSTAS_SUCCESS,
    payload: {totals}
  }),
  getPropostas: id => ({
    type: Types.GET_PROPOSTAS,
    payload: {id}
  }),
  getPropostasSuccess: data => ({
    type: Types.GET_PROPOSTAS_SUCCESS,
    payload: {data}
  }),
  getDocsPropostas: id => ({
    type: Types.GET_DOCS_PROPOSTAS,
    payload: {id}
  }),
  getDocsPropostasSuccess: data => ({
    type: Types.GET_DOCS_PROPOSTAS_SUCCESS,
    payload: {data}
  }),
  editPropostas: data => ({
    type: Types.EDIT_PROPOSTAS,
    payload: data
  }),
  ratePropostas: data => ({
    type: Types.RATE_PROPOSTAS,
    payload: data
  }),
  addPropostas: data => ({
    type: Types.ADD_PROPOSTAS,
    payload: data
  }),
  deletePropostas: () => ({
    type: Types.DELETE_PROPOSTAS
  }),
  searchPropostas: filter => ({
    type: Types.SEARCH_PROPOSTAS,
    payload: {filter}
  }),
  changePropostasPage: page => ({
    type: Types.CHANGE_PAGE_PROPOSTAS,
    payload: {page}
  }),
  changePropostasRowsPerPage: total => ({
    type: Types.CHANGE_ROWS_PER_PAGE_PROPOSTAS,
    payload: {total}
  }),
  getListPropostasSelects: () => ({
    type: Types.GET_LIST_PROPOSTAS_SELECTS
  }),
  getListPropostasSuccessSelects: propostas => ({
    type: Types.GET_LIST_PROPOSTAS_SUCCESS_SELECTS,
    payload: {propostas}
  }),
  print: id => ({
    type: Types.PRINT,
    payload: {id}
  }),
  printSuccess: url => ({
    type: Types.PRINT_SUCCESS,
    payload: {url}
  }),
  changeFilter: data => ({
    type: Types.CHANGE_FILTER,
    payload: {data}
  }),
  checkColumn: settings => ({
    type: Types.CHECK_COLUMN,
    payload: {settings}
  }),
  checkColumnSuccess: columns => ({
    type: Types.CHECK_COLUMN_SUCCESS,
    payload: {columns}
  }),
  deleteAllPropostas: selected => ({
    type: Types.DELETE_ALL_PROPOSTAS,
    payload: {selected}
  }),
  getPropostaHistory: id => ({
    type: Types.GET_PROPOSTA_HISTORY,
    payload: {id}
  }),
  getPropostaHistorySuccess: data => ({
    type: Types.GET_PROPOSTA_HISTORY_SUCCESS,
    payload: {data}
  }),
  setPropostasReportFilter: data => ({
    type: Types.SET_PROPOSTAS_REPORT_FILTER,
    payload: {data}
  }),
  getPropostasRelatorio: () => ({
    type: Types.GET_PROPOSTAS_RELATORIO,
  }),
  getPropostasRelatorioSuccess: data => ({
    type: Types.GET_PROPOSTAS_RELATORIO_SUCCESS,
    payload: {data}
  }),
};



// WEBPACK FOOTER //
// ./src/store/ducks/propostas.js